import * as React from "react";
import {
    Button,
    FormControl,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select,
    TextField,
} from "@mui/material";
import { useState } from "react";

const HistogramFilterComponent = (props: any) => {
    const { updateFilterData, index } = props;
    const [yAxisUnitValue, setYAxisUnitValue] = useState<any>(['Normalized']);
    const [bucketSize, setBucketSize] = useState<any>(5);
    const [yAxisMajorInterval, setYAxisMajorInterval] = useState<any>(null);
    const [yAxisMinorInterval, setYAxisMinorInterval] = useState<any>(null);
    const [yAxisMaxValue, setYAxisMaxValue] = useState<any>(null);

    const handleApplySubmit = () => {
        const data = {
            yAxisMaxValue,
            yAxisMajorInterval,
            yAxisMinorInterval,
            yAxisUnitValue,
            bucketSize,
            index: index
        }
        updateFilterData(data);
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
            justifyContent: 'space-evenly'
        }}>

            <FormControl style={{ width: '100%' }}
            >
                <InputLabel htmlFor="grouped-native-select">Y axis Units Value</InputLabel>
                <Select
                    id="modelSelect"
                    value={yAxisUnitValue}
                    defaultValue={['Normalized']}
                    onChange={(event: any) => {
                        const {
                            target: { value },
                        } = event;
                        setYAxisUnitValue(value);
                    }}
                    input={<OutlinedInput label="Y axis Units Value" />}
                >
                    {['Normalized', 'Absolute Frequency'].map((item: any, index: number) => (
                        <MenuItem key={index} value={item}>
                            <ListItemText primary={item} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <FormControl style={{ width: '100%' }}
            >
                <TextField id="outlined-basic" type="number" label="Y axis major Intervals" variant="outlined" onChange={(e: any) => { setYAxisMajorInterval(parseFloat(e?.target?.value)) }} />
            </FormControl>

            <FormControl style={{ width: '100%' }}
            >
                <TextField id="outlined-basic" type="number" label="Y axis minor Intervals" variant="outlined" onChange={(e: any) => setYAxisMinorInterval(parseFloat(e?.target?.value))} />

            </FormControl>
            <FormControl style={{ width: '100%' }}
            >
                <TextField id="outlined-basic" type="number" label="Y axis MAX. Value" variant="outlined" onChange={(e: any) => setYAxisMaxValue(parseFloat(e?.target?.value))} />

            </FormControl>
            <FormControl style={{ width: '100%' }}
            >
                <TextField id="outlined-basic" type="number" label="Bucket Size or Quantity" variant="outlined" onChange={(event: any) => {
                    const {
                        target: { value },
                    } = event;
                    if (value) {
                        setBucketSize(Number(value))
                    } else {
                        setBucketSize(5)
                    }
                }
                } />

            </FormControl>
            <Button variant='contained' style={{ width: '25%', alignSelf: 'center' }} onClick={handleApplySubmit}>APPLY</Button>
        </div>
    );
};

export default HistogramFilterComponent;  